module.exports = __webpack_public_path__ + "img/cybersecurity.2dd7214e.png";